import { Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setLanguageType } from "./redux/slice/sliceHome";
import PopUpExternal from "./components/PopupExternal";
import {
  setExternalLink,
  setShowExternalPopup,
  setShowHomePopup,
} from "./redux/slice/slicePopup";
import { useGetProtectedApiDataQuery } from "./redux/services/apiSlice";
import PopUpHome from "./components/PopUpHome";

function App() {
  const { languageType } = useSelector((state) => state.homeSlice);
  const dispatch = useDispatch();
  const { data: homePopupData = [], isLoading: homePopupIsLoading } =
    useGetProtectedApiDataQuery({
      url: "home_popup",
      lang: languageType,
    });

  // useEffect(() => {
  //   if (
  //     !homePopupIsLoading &&
  //     homePopupData[0]?.field_status_of_popup === "On"
  //   ) {
  //     dispatch(setExternalLink(homePopupData[0]?.body));
  //     dispatch(setShowHomePopup(true));
  //   } else if (!homePopupIsLoading) {
  //     dispatch(setShowExternalPopup(false));
  //   }
  // }, [homePopupData, homePopupIsLoading, dispatch]);

  // useEffect(() => {
  //   // Check session storage for popup state
  //   const isPopupShown = sessionStorage.getItem("isHomePopupShown");

  //   if (
  //     !homePopupIsLoading &&
  //     homePopupData[0]?.field_status_of_popup === "On" &&
  //     !isPopupShown
  //   ) {
  //     dispatch(setExternalLink(homePopupData[0]?.body));
  //     dispatch(setShowHomePopup(true));

  //     // Set popup shown flag in session storage
  //     sessionStorage.setItem("isHomePopupShown", "true");
  //   } else if (!homePopupIsLoading) {
  //     dispatch(setShowExternalPopup(false));
  //   }
  // }, [homePopupData, homePopupIsLoading, dispatch]);

  useEffect(() => {
    const storedLanguage = localStorage.getItem("languageType");
    if (storedLanguage === "en") {
      dispatch(setLanguageType(""));
    } else if (storedLanguage === "hi") {
      dispatch(setLanguageType("hi"));
    }
  }, [dispatch]);

  // website title
  useEffect(() => {
    if (languageType === "hi") {
      document.title = "नीपको में स्वागत है";
    } else {
      document.title = "Welcome to NEEPCO";
    }
  }, [languageType]);

  const { fontSize } = useSelector((state) => state.homeSlice);
  return (
    // <div style={{ fontSize }}>
    <>
      <Routes>
        <Route path="/*" element={<Layout />}></Route>
      </Routes>
      <PopUpExternal />
      <PopUpHome />
    </>
    // </div>
  );
}

export default App;
